<template>
  <div>
    <p class="text-2xl mt-4 font-bold text-center">{{ models[0].brand }}</p>
    <div v-if="!info" class="grid grid-cols-2 lg:grid-cols-4 gap-x-4 mt-6">
      <button
        v-for="(car, i) in models"
        :key="i"
        class="flex items-center justify-center border-2 hover:border-active hover:cursor-pointer rounded-2xl h-12 py-3 px-5 font-bold"
        @click="info = car"
      >
        {{ car.model }}
      </button>
    </div>
    <div
      v-if="info"
      class="mt-6 text-left inline-block font-bold text-xl w-full"
    >
      <p
        class="border-b-2 border-dashed border-black pt-2 flex justify-between"
      >
        Скорости <span>{{ info.gearbox }}</span>
      </p>
      <p
        class="border-b-2 border-dashed border-black pt-2 flex justify-between"
      >
        Тип гориво <span>{{ info.fuel_type }}</span>
      </p>
      <p
        class="border-b-2 border-dashed border-black pt-2 flex justify-between"
      >
        Година <span>{{ info.year }}</span>
      </p>
      <p
        class="border-b-2 border-dashed border-black pt-2 flex flex-col md:flex-row justify-between"
      >
        Градско/Извънградско/Комбинирано:
        <span
          >{{ info.fuel_consumption_city }}/{{ info.fuel_consumption_urban }}/{{
            info.fuel_consumption_combined
          }}
          литра</span
        >
      </p>
      <p
        class="border-b-2 border-dashed border-black pt-2 flex justify-between"
      >
        Цвят <span>{{ info.color }}</span>
      </p>

      <p
        class="border-b-2 border-dashed border-black pt-2 flex flex-col md:flex-row justify-between"
      >
        Цени 1 ден/2 дни/3 дни/Седмица/Месец:
        <span
          >{{ info.price_1 }}/{{ info.price_2 }}/{{ info.price_1 }}/{{
            info.price_week
          }}/{{ info.price_month }} лева</span
        >
      </p>
      <form @submit.prevent="sendRequest">
        <div
          class="flex flex-col xl:flex-row gap-y-4 xl:gap-y-0 xl:gap-x-4 mt-14"
        >
          <input
            type="text"
            v-model="name"
            class="h-12 rounded-xl p-4 bg-gray-100"
            placeholder="Име"
            required
          />
          <input
            type="text"
            v-model="phone"
            class="h-12 rounded-xl p-4 bg-gray-100"
            placeholder="Телефон"
            required
          />
        </div>
        <button
          type="submit"
          class="bg-active text-white font-bold rounded-full py-4 px-8 mt-6"
        >
          <svg
            v-if="loading"
            class="animate-spin -mr-1 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0
                  3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <span v-else>Изпрати запитване</span>
        </button>
      </form>
    </div>
    <button
      v-if="info"
      @click="info = null"
      class="absolute bottom-0 left-0 bg-black text-white w-20 h-20 rounded-tr-full flex items-center justify-center hover:cursor-pointer"
    >
      <svg
        class="relative -left-2"
        fill="#fff"
        height="32px"
        width="32px"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 472.615 472.615"
        xml:space="preserve"
      >
        <g>
          <g>
            <path
              d="M167.158,117.315l-0.001-77.375L0,193.619l167.157,153.679v-68.555c200.338,0.004,299.435,153.932,299.435,153.932
			c3.951-19.967,6.023-40.609,6.023-61.736C472.615,196.295,341.8,117.315,167.158,117.315z"
            />
          </g>
        </g>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "AvailableModels",
  props: {
    models: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      info: null,
      name: "",
      phone: "",
      loading: false,
    };
  },
  methods: {
    sendRequest() {
      this.loading = true;
      const data = {
        name: this.name,
        phone: this.phone,
        car: this.info.id,
      };
      this.$emit("send-request", data);
    },
  },
};
</script>
